import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchDistributorOrders = createAsyncThunk("fetchDistributorOrders", async ({ page, limit, filters }) => {
	const params = new URLSearchParams({
		page: page || 1,
		limit: limit || 10,
		distributor_code: filters?.distributor_code?.trim() || "",
		distributor_name: filters?.distributor_name?.trim() || "",
		product_id: filters?.product_id?.trim() || "",
	});

	const response = await axiosHttp.get(`distributor/orders?${params}`);
	return response.data;
});

const DistributorOrdersSlice = createSlice({
	name: "DistributorOrdersSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		total: 0,
		page: 1,
		limit: 10,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchDistributorOrders.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchDistributorOrders.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload?.data;
			state.total = action.payload.pagination?.totalRecords || 0;
			state.page = action.payload.pagination.currentPage || 1;
		});
		builder.addCase(fetchDistributorOrders.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload.data;
		});
	},
});

export default DistributorOrdersSlice.reducer;
